<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><div class="acknowledgments" id="acknowledgments_1">
<p class="fmh"><a href="#/NoControl_toc#ackn_1"><strong>ACKNOWLEDGMENTS</strong></a></p>
<p class="p1">I have a lot of people to thank for helping me make this book so much better than it would have been otherwise: my agent, Nephele Tempest, my editor, Michele Bidelspach, and my beta readers, Dyann, Julie, Karen, Michelle, Sara, Sherry and Tonia. Your efforts, input, and encouragement are an invaluable help to me, and I can’t thank you enough.</p>
</div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NoControl_ackn_1.vue?30ed1478